import React, { useState, useEffect} from "react";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { Tabs,Tab } from "react-bootstrap";
import { SystemPrompts } from "./SystemPrompts";
import { GenAIPrompts } from "./GenAIPrompts";

export const GenAITabs = () => {
    const [activeTab,setActiveTab]=useState("Usage Logs");

    useEffect(()=>{
        document.title="ChatBot Usage Logs";
    },[])
  let Level = [{ BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` }];
  Level = [
    ...Level,
    { BreadCrumb: "ChatBot Usage Logs", Routes: `${UrlPath.ChatBotUsageLogs}` },
  ];

  return (
    <>
      <TopBar label={"ChatBot Logs"} />
      <div className="mainContentData">
        <BreadCrumbs Levels={Level} />
        <Tabs activeKey={activeTab} onSelect={(key)=>{setActiveTab(key)}}>
                <Tab className="life-science rounded  border-top-0 "  eventKey="Usage Logs" title="Usage Logs" >
                 {activeTab==="Usage Logs" &&<GenAIPrompts/>}
                </Tab>
                <Tab  className="life-science rounded  border-top-0" eventKey="System Prompts" title="System Prompts">
                {activeTab==="System Prompts" && <SystemPrompts/>}
                </Tab>
            </Tabs>
      </div>
    </>
  );
};
